import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Orientation } from 'shared/models/idt-components/idt-component.models';


@Injectable()
export class IdtSharedRenderService {

  public screenOrientation$ = new BehaviorSubject<Orientation>('landscape');
  private readonly renderer: Renderer2;

  constructor(
    private readonly rendererFactory: RendererFactory2
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
    this.checkCurrentScreenOrientation();
    this.renderer.listen('window', 'resize', this.checkCurrentScreenOrientation.bind(this));
  }

  public getCurrentScreenOrientation(target = window): Orientation {
    return target.innerHeight > target.innerWidth ? 'portrait' : 'landscape';
  }

  public checkCurrentScreenOrientation(): void {
    const orientation = this.getCurrentScreenOrientation();
    this.screenOrientation$.next(orientation);
  }

}
